export default {
	required: v => !!v,
	min_length: (v, min_length = 7) => v.length >= min_length,
	email: {
		required: v => !!v,
		invalid: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v),
	},
	name: {
		required: v => {

            if (!v) return false

            const value = v.trim()

            return !!value

        },
	},
	cnpj: {
		required: v => !!v,
		invalid: cnpj => {
			cnpj = cnpj.replace(/[^\d]+/g, '');
			
			if (cnpj.length !== 14) {
				return false;
			}
			
			if (cnpj === '00000000000000'
				|| cnpj === '11111111111111'
				|| cnpj === '22222222222222'
				|| cnpj === '33333333333333'
				|| cnpj === '44444444444444'
				|| cnpj === '55555555555555'
				|| cnpj === '66666666666666'
				|| cnpj === '77777777777777'
				|| cnpj === '88888888888888'
				|| cnpj === '99999999999999') {
				
				return false;
			}
			
			let size = cnpj.length - 2; // 12
			
			let numbers = cnpj.substring(0, size);
			let pos = size - 7;
			let sum = 0;
			
			const digits = cnpj.substring(size);
			
			for (let i = size; i >= 1; i--) {
				sum += numbers.charAt(size - i) * pos--;
				if (pos < 2) {
					pos = 9;
				}
			}
			
			let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
			if (result !== parseInt(digits.charAt(0))) {
				return false;
			}
			
			size = size + 1;
			numbers = cnpj.substring(0, size);
			sum = 0;
			pos = size - 7;
			for (let j = size; j >= 1; j--) {
				sum += numbers.charAt(size - j) * pos--;
				if (pos < 2) {
					pos = 9;
				}
			}
			
			result = sum % 11 < 2 ? 0 : 11 - sum % 11;
			
			return result === parseInt(digits.charAt(1));
		},
	},
	password: {
		required: v => !!v,
		min_length: (v, min_length = 7) => {
            if (v == '') return true

            return v.length >= min_length

        } ,
		required_characters: v => !!v,
	},
	website: {
        required: v => !!v,
        http: v => {

            if (v == '') return true

            return RegExp('\\b'+ 'http' +'\\b').test(v) || RegExp('\\b'+ 'https' +'\\b').test(v)

        }
	},
	phone: {
        required: v => !!v,
        only_numbers: v => !v || /^[0-9 ()+-]+$/.test(v),
        min_length: (v, min_length = 13) => v.length >= min_length,
        min_length_es: (v, min_length = 5) => v.length >= min_length,
	},
	file: {
        required: v => !!v,
        only_img: v => {

            if(!v) return true
            
            const extensions = ['.jpeg', '.png', '.jpg']

            let isImg = false     

            for (const extension of extensions) {

                if (v.name.endsWith(extension)) isImg = true

            }

            return isImg

        },
        only_km: v => {

            if(!v) return true
            
            const extensions = ['.kml', '.kmz']

            let isKm = false     

            for (const extension of extensions) {

                if (v.name.endsWith(extension)) isKm = true

            }

            return isKm

        },
	},
	facebook: {
        required: v => !!v,
        isFacebook: v =>  { 
            if (v == '') return true
            if (v.search('facebook') === -1) return false 
            return true
        }, 
        http: v => {
            if (v == '') return true

            return RegExp('\\b'+ 'http' +'\\b').test(v) || RegExp('\\b'+ 'https' +'\\b').test(v)
        }
	},
};
